import { number, pipe, string, transform, union } from 'valibot';

/**
 * @private
 */
export const IdSchema = pipe(
  union([string(), number()]),
  transform((input) => input.toString())
);
